import * as React from 'react';
import { notifyEsales } from '.';
import { historyEvent, HistoryEventType } from '@avensia/excite';

export function useEsalesClickNotifications() {
  React.useEffect(
    () =>
      historyEvent.on(e => {
        if (e.event === HistoryEventType.Push && e.options?.linkIdentifier) {
          notifyEsales('click', e.options.linkIdentifier);
        }
      }),
    [],
  );
}
